import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import WeatherChart from 'features/weatherWalls/WeatherChart';
import { ForecastDto } from 'types';
import { SelectedChart } from './types';

interface Props {
  handleClose: () => void;
  forecast: ForecastDto | null | undefined;
  fullScreenChart: SelectedChart;
  lastUpdated: string;
  locationName: string;
}
const ForecastFullscreenPopup = ({
  handleClose,
  forecast,
  fullScreenChart,
  lastUpdated,
  locationName,
}: Props) => {
  if (!forecast || fullScreenChart === 'none') return null;
  return (
    <Dialog
      sx={{ zIndex: 9999999999 }}
      fullWidth
      maxWidth='xl'
      open={true}
      onBackdropClick={handleClose}
    >
      <DialogTitle>Forecast for {locationName}</DialogTitle>
      <DialogContent>
        {forecast && (
          <Grid container>
            <Grid item xs>
              <WeatherChart
                weatherData={forecast?.hourlyForecast}
                measurement={fullScreenChart}
                locationName=''
                durationLabel=''
                spanGaps
              />
            </Grid>
            <Grid sx={{ pt: '1rem' }} item container justifyContent='flex-end'>
              <Typography color={grey[500]} variant='body2'>
                {'Last updated: ' + lastUpdated}
              </Typography>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions style={{ paddingTop: 0 }}>
        <Button onClick={handleClose}>Back</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForecastFullscreenPopup;
